import React, { memo } from 'react';
import { useHashModal } from '@/hooks/useHashModal';

interface HashDrawerConfig {
  action: string;
}

interface WithHashDrawerProps {
}

function withHashDrawer<P extends object>(
  WrappedComponent: React.ComponentType<P>,
  config: HashDrawerConfig
) {
  const HashDrawerWrapper = memo(function HashDrawerWrapper(
    props: WithHashDrawerProps & Omit<P, 'isOpen' | 'onClose'>
  ) {
    const { currentId, currentAction, onClose, navigateToModal } = useHashModal();

    if (currentAction !== config.action) {
      return null;
    }

    return (
      <WrappedComponent
        {...(props as P)}
        isOpen={true}
        onClose={onClose}
        navigateToModal={navigateToModal}
        entityId={currentId ? parseInt(currentId, 10) : undefined}
      />
    );
  });

  HashDrawerWrapper.displayName = `withHashDrawer(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return HashDrawerWrapper;
}

export default withHashDrawer;
